import { pdfjsWorkerSrc } from '../../utils/pdfjsWorkerSrc';

export function pdfPageRenderScale(devicePixelRatio = 1): number {
  return Math.min(2.5, Math.max(1.8, Number(devicePixelRatio) || 1));
}

export async function renderPdfSourceToPageImages(src: string): Promise<string[]> {
  const pdfjs = await import('pdfjs-dist');
  pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorkerSrc;
  const pdf = await pdfjs.getDocument(src).promise;
  const images: string[] = [];
  const scale = pdfPageRenderScale(typeof window !== 'undefined' ? window.devicePixelRatio : 2);

  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
    const page = await pdf.getPage(pageNum);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Could not prepare this page.');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({ canvas, canvasContext: context, viewport }).promise;
    images.push(canvas.toDataURL('image/jpeg', 0.92));
  }

  return images;
}
